// extracted by mini-css-extract-plugin
module.exports = {"apkCenterHeader":"MarketList_apkCenterHeader-3i9-S"};